import { Button, Icon, Spinner, Tooltip } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { TOGGLE_ARCHIVE } from 'modules/Recommendations/Audits/store/types'

export const ArchiveToggleButton = ({
  action,
  id,
  processing = false,
  className = '',
}) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const handleClick = useCallback(
    () =>
      dispatch({
        type: TOGGLE_ARCHIVE,
        payload: { ids: [id], action },
      }),
    [],
  )

  return (
    <Tooltip title={t(`audits::list.extra_actions.${action}`)}>
      {processing ? (
        <Spinner width={24} />
      ) : (
        <Button
          noLabel
          startIcon={
            <Icon
              name={action === 'archive' ? 'inbox-archive' : 'inbox-upload'}
            />
          }
          bgColor={'none'}
          bgColorHover={'none'}
          bgColorActive={'none'}
          color={'Label-GU-Primary'}
          size={'m'}
          className={className}
          onClick={handleClick}
        />
      )}
    </Tooltip>
  )
}

ArchiveToggleButton.propTypes = {
  action: PropTypes.string,
  id: PropTypes.number,
  login: PropTypes.string,
  icon: PropTypes.string,
  processing: PropTypes.bool,
  className: PropTypes.string,
  toggleTo: PropTypes.oneOf(['activate', 'archive']),
  checkboxHandleChange: PropTypes.func,
}
